//
//
//
//
//
//
//
//
//
//
//

export default {
  head(){
      return {
          title: 'No se encontró esta página - Focomotor'
      }
  },
}
